export default __webpack_public_path__ + "static/media/Prologue_Haven2US.17baff00.png";